export class Marketplace extends String {
  constructor(
    public value: string,
    public name: string,
  ) {
    super(name);
  }
}

export const VLMarketplacesItems = {
  Ticketmaster: 'NOTNOW',
  SeatGeek: 'NOSEATGEEK',
  TickPick: 'NOTP',
  'Ticket Network': 'NOTND',
  'Ticket Evolution': 'NOTEVO',
  Gametime: 'NOGT',
  AXS: 'NOAXS',
  'Vivid Seats': 'NOVIVID',
  GoTickets: 'NOGO',
  StubHub: 'NOSTUB',
} as const;

export const VLMarketplaces: Record<keyof typeof VLMarketplacesItems, Marketplace> = Object.assign(
  {},
  ...Object.entries(VLMarketplacesItems).map(([key, value]) => ({ [key]: new Marketplace(value, key) })),
);

export function getSelectedMarketplaces(internalNotes: string) {
  return Object.entries(VLMarketplacesItems)
    .filter(([, value]) => !internalNotes.includes(value))
    .map(([key, value]) => new Marketplace(value, key));
}

export function getOmittedMarketplaces(internalNotes: string) {
  return Object.entries(VLMarketplacesItems).filter(([, value]) => internalNotes.includes(value));
}

export function generateNewInternalNotes(internalNotes: string, selectedMarketplaces: Marketplace[]) {
  const internalNotesParts = internalNotes.split(' ');

  // Remove any parts that match a marketplace item exclusion note
  const cleanedNotesParts = internalNotesParts.filter((p) => !selectedMarketplaces.map((m) => m.value).includes(p));

  // Re-add everything that's not in the selected marketplaces
  const omittedMarketplaces = Object.entries(VLMarketplacesItems).filter(([, value]) => !selectedMarketplaces.map((m) => m.value).includes(value));

  return [...cleanedNotesParts, ...omittedMarketplaces.map(([, value]) => value)].join(' ').trim();
}
